import { OrderStatus } from 'types/OrderStatus.type';

import type { BadgeProps } from '@frontend/legacy-components';

import { ORDER_STATUS, ORDER_STATUS_LABEL } from 'constants/all';

import StatusBadge from './StatusBadge';

const PROPS_BY_STATUS: Record<OrderStatus, Partial<BadgeProps> | null> = {
  [ORDER_STATUS.ALL]: null,
  [ORDER_STATUS.PENDING]: {
    colorScheme: 'info',
    variant: 'solid',
  },
  [ORDER_STATUS.CONFIRMED]: {
    colorScheme: 'success',
    variant: 'subtle',
  },
  [ORDER_STATUS.ON_HOLD]: {
    colorScheme: 'warning',
    variant: 'subtle',
  },
  [ORDER_STATUS.IN_PROCESS]: {
    colorScheme: 'warning',
    variant: 'solid',
  },
  [ORDER_STATUS.COMPLETED]: {
    colorScheme: 'success',
    variant: 'solid',
  },
  [ORDER_STATUS.CANCELLED]: {
    bg: 'feature.placeholder',
    borderColor: 'feature.placeholder',
    color: 'feature.onInteraction',
  },
} as const;

type OrderStatusBadgeProps = {
  orderStatus?: OrderStatus;
} & BadgeProps;

const OrderStatusBadge = ({ orderStatus, ...rest }: OrderStatusBadgeProps) => {
  return (
    <StatusBadge
      status={orderStatus}
      propsByStatus={PROPS_BY_STATUS}
      labelByStatus={ORDER_STATUS_LABEL}
      {...rest}
    />
  );
};

export default OrderStatusBadge;
